// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarFonteService = async (data: any) => {
  const URL = `${Globais.DOMINIOBACK}/fonte`;
  try {
    const response = await axios.post(URL, data);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
